import Rest from '../Rest'

/**
 * Extrato de taxas da plataforma (fee breakdown por venda).
 * Grid: GET /api/v1/financial/fees/statement/grid
 * Export: /api/v1/reports/financial_fees/grid/export/{type} (via ReportService do Grid)
 */
export default class FeeStatementService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/financial/fees/statement'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }
}
